import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'
import {GetAllUserAccount} from '../../AllCellCastUser/UserListSlice/UserListSlice'
import {
  getDedicatedNumberList,
  updateDedicatedNumberList,
} from '../DedicatedNumberSlice/DedicatedNumberSlice'
import {countries, useDebounce} from '../../../../../_metronic/helpers'

import Select from 'react-select'
import {dark} from '@material-ui/core/styles/createPalette'
import {Formik, Form, Field, ErrorMessage} from 'formik'
import {
  AdminDedicatedNumber,
  EditAdminDedicatedNumber,
} from '../../../../Utils/_helpers/ValidationSchema'
import {string} from 'yup'

const EditDedicatedNumber = ({data, show, handleClose, setData, page}: any) => {
  const paymentGatewayList = useSelector((state: any) => state?.paymentGateway?.GatewayManagement)
  const userAccList = useSelector((state: any) => state?.UserAccount?.userAccountList?.items)

  const dispatch = useDispatch()
  const [error, setError] = useState<any>({})
  const [startDate, setStartDate] = useState(new Date())
  const [pageSearch, setPageSearch] = useState({
    page: 1,
    size: 10,
    search: '',
    role: 'owner',
  })

  const debouncedSearchTerm = useDebounce(pageSearch?.search, 500)
  const handleSubmit = (value: any) => {
    const billStatus =
      typeof value?.billingStatus == 'string' ? value?.billingStatus : value?.billingStatus?.value
    dispatch(
      updateDedicatedNumberList({
        _id: value?._id,
        audNumber: value?.audNumber?.trim(),
        gateway: value?.gateway,
        country: value?.country,
        assignedUser: value?.assignedUser?.value,
        billingStatus: billStatus,
        activationTime: billStatus !== '' ? value?.activationTime : undefined,
        expirationTime: billStatus !== '' ? value?.expirationTime : undefined,
        status: value?.status,
      })
    ).then(() => {
      dispatch(getDedicatedNumberList(page))
    })
    handleClose()
  }

  useEffect(() => {
    dispatch(GetAllUserAccount(pageSearch))
  }, [debouncedSearchTerm])

  const handleValidation = (value: any) => {
    const errors: any = {}

    if (
      !/^\(?(?:\+?61|0)(?:(?:2\)?[ -]?(?:3[ -]?[38]|[46-9][ -]?[0-9]|5[ -]?[0-35-9])|3\)?(?:4[-]?[0-57-9]|[57-9][ -]?[0-9]|6[ -]?[1-67])|7\)?[ -]?(?:[2-4][ -]?[0-9]|5[ -]?[2-7]|7[ -]?6)|8\)?[ -]?(?:5[ -]?[1-4]|6[ -]?[0-8]|[7-9][ -]?[0-9]))(?:[ -]?[0-9]){6}|4\)?[ -]?(?:(?:[01][ -]?[0-9]|2[ -]?[0-57-9]|3[ -]?[1-9]|4[ -]?[7-9]|5[ -]?[018])[ -]?[0-9]|3[ -]?0[ -]?[0-5])(?:[ -]?[0-9]){5})$/.test(
        value?.audNumber?.trim()
      )
    ) {
      errors.mobile = 'please enter valid number'
    }
    if (value?.audNumber?.trim() == '') {
      errors.mobile = 'please enter  number'
    }
    if (value?.country == '') {
      errors.country = 'Please select contry'
    }
    if (value?.gateway == '') {
      errors.gateway = 'Please select gateway'
    }
    // if (value?.billingStatus) {
    //   errors.billingStatus = 'please select Billing status'
    // }
    // if (value?.assignedUser) {
    //   errors.assignedUser = 'please select Billing status'
    // }

    setError({...errors})

    return errors
  }
  const billingOption = [
    {value: '', label: 'Select'},
    {value: 'monthly', label: 'Monthly', isDisabled: true},
    {value: 'yearly', label: 'Yearly', isDisabled: true},
    {value: 'free', label: 'Free'},
  ]

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header'>
          <h2>Edit Dedicated Number</h2>
        </div>
        <div className='modal-body p-10 admin_list_modals'>
          <Formik
            initialValues={data}
            validationSchema={EditAdminDedicatedNumber}
            onSubmit={handleSubmit}
          >
            {({isSubmitting, values, setFieldValue}: any) => (
              <Form>
                <div>
                  <label className=' col-form-label required fw-bold fs-6' htmlFor='audNumber'>
                    Gateway Number
                  </label>
                  <Field
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    type='text'
                    id='audNumber'
                    name='audNumber'
                    placeholder='Gateway Number'
                  />
                  <ErrorMessage className='text-danger' name='audNumber' component='div' />
                </div>
                <div>
                  <label className=' col-form-label required fw-bold fs-6' htmlFor='country'>
                    Country
                  </label>
                  <Select
                    value={{
                      value: countries?.find((key: any) => key?.value === values?.country)?.value,
                      label: countries?.find((key: any) => key?.value === values?.country)?.label,
                    }}
                    onChange={(e: any) => setFieldValue('country', e?.value)}
                    options={countries}
                  />
                  <ErrorMessage className='text-danger' name='country' component='div' />
                </div>
                <div>
                  <label className=' col-form-label required fw-bold fs-6' htmlFor='gateway'>
                    Gateway
                  </label>
                  <Select
                    value={{
                      value:
                        paymentGatewayList?.find((key: any) => key?._id === values?.gateway)?._id ||
                        '',
                      label: `${
                        paymentGatewayList?.find((key: any) => key?._id === values?.gateway)?.DB ||
                        'Select'
                      }-${
                        paymentGatewayList?.find((key: any) => key?._id === values?.gateway)
                          ?.gatewayName || 'Gateway'
                      }`,
                    }}
                    onChange={(e: any) => setFieldValue('gateway', e.value)}
                    options={[
                      {value: '', label: 'select'},
                      ...paymentGatewayList?.map((key: any, id: number) => ({
                        value: `${key?._id}`,
                        label: `${key?.DB}-${key?.gatewayName}`,
                      })),
                    ]}
                  />
                  <ErrorMessage className='text-danger' name='gateway' component='div' />
                </div>

                <div>
                  <label className=' col-form-label  fw-bold fs-6' htmlFor='Assigned'>
                    Assigned user
                  </label>
                  <Select
                    value={values?.assignedUser}
                    onInputChange={(e: any) => setPageSearch({...pageSearch, search: e})}
                    onChange={(e: any) => setFieldValue('assignedUser', e)}
                    options={[
                    {value: '', label: 'select'},
                    ...userAccList?.map((key: any) => ({
                      value: key?._id,
                      label: `${key?.name} (${key?.email})`,
                    }))]}
                  />
                  <ErrorMessage className='text-danger' name='Billing' component='div' />
                </div>

                <div>
                  <label className=' col-form-label  fw-bold fs-6' htmlFor='Billing'>
                    Billing Status
                  </label>
                  <Select
                    placeholder={'Select'}
                    value={billingOption?.find((key: any) => key?.value === values?.billingStatus)}
                    onChange={(e: any) => {
                      if (e.value == 'free') {
                        setFieldValue('billingStatus', e)
                        setFieldValue('expirationTime', new Date())
                      } else {
                        setFieldValue('billingStatus', e)
                        setFieldValue('expirationTime', '')
                      }
                    }}
                    options={billingOption}
                  />
                  {/* <ErrorMessage className='text-danger' name='' component='div' /> */}
                </div>
                {(values?.billingStatus?.value == 'free' || values?.billingStatus == 'free') && (
                  <div>
                    <label className=' col-form-label required fw-bold fs-6'>
                      Free plan Length{' '}
                    </label>

                    <DatePicker
                      className='form-select form-select-solid form-select-lg fw-bold'
                      minDate={moment().toDate()}
                      selected={new Date(data?.expirationTime)}
                      onChange={(e: any) => {
                        setFieldValue('expirationTime', e)
                        setData({...data, expirationTime: e})
                      }}
                    />
                  </div>
                )}
                <div className='col-lg-8 d-flex align-items-center mt-5'>
                  <div className='form-check form-check-solid form-switch fv-row'>
                    <input
                      className='form-check-input w-45px h-30px'
                      type='checkbox'
                      id='allowmarketing'
                      checked={data.status == 'active'}
                      onChange={(e: any) => {
                        let val = e.target.checked ? 'active' : 'inactive'
                        console.log(val, e.target.checked, 'lllllllllllll')
                        setFieldValue('status', val)
                        setData({...data, status: val})
                      }}
                    />
                    <label className='form-check-label'></label>
                  </div>
                </div>

                <div className='d-flex flex-center mt-5'>
                  <div id='kt_drawer_chat_close'>
                    <button
                      type='button'
                      onClick={() => {
                        handleClose()
                      }}
                      className='btn btn-sm gray_bg_purple me-2'
                    >
                      Cancel
                    </button>
                  </div>
                  <button
                    type='submit'
                    className='btn btn-sm btn-light btn-primary fw-500   w-100px p-3 border border-primary'
                  >
                    Submit
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  )
}

export default EditDedicatedNumber
